import { API_BASE_URL } from "../../config";

async function fetchLaborData() {
  try {
    const [lausResponse, industryResponse] = await Promise.all([
      fetch(`${API_BASE_URL}/lausRates`),
      fetch(`${API_BASE_URL}/industryJobs`)
    ]);
    
    const lausData = await lausResponse.json();
    const industryData = await industryResponse.json();
    
    return {
      lausRatesData: lausData,
      industryJobsData: industryData
    };
  } catch (error) {
    console.error('Error fetching labor data:', error);
    return {
      lausRatesData: [],
      industryJobsData: []
    };
  }
}

export const { lausRatesData, industryJobsData } = await fetchLaborData();